import { useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useIntegrations } from "@/hooks/useIntegrations";

export function IntegrationsSection() {
  const { t } = useTranslation();
  const { providers, loading, error } = useIntegrations();

  if (loading) {
    return (
      <div className="flex items-center gap-2 py-4 text-muted-foreground">
        <Loader2 className="h-4 w-4 animate-spin" />
        <span>{t("projectPortal.config.integrations.loading")}</span>
      </div>
    );
  }

  if (error) {
    return <p className="py-4 text-sm text-destructive">{error}</p>;
  }

  if (providers.length === 0) {
    return (
      <p className="py-4 text-sm text-muted-foreground">
        {t("projectPortal.config.integrations.empty")}
      </p>
    );
  }

  return (
    <div className="grid gap-3 sm:grid-cols-2">
      {providers.map((provider) => (
        <div
          key={provider.provider}
          className="flex items-center justify-between rounded-lg border p-4"
        >
          <div>
            <p className="text-sm font-medium">{provider.provider}</p>
            <p className="text-xs text-muted-foreground">
              @{provider.username}
            </p>
          </div>
          <Badge
            variant={provider.token_valid === false ? "destructive" : "default"}
          >
            {provider.token_valid === false
              ? t("projectPortal.config.integrations.tokenExpired")
              : t("projectPortal.config.integrations.connected")}
          </Badge>
        </div>
      ))}
    </div>
  );
}
